import type { IconName } from "@similarweb/icons";
import type { GAPieData } from "app/pages/activation/types/api";

export enum WidgetType {
    Graph = "Graph",
    Pie = "Pie",
}

export type ConfigSchema = {
    title: string;
    icon: IconName;
    tooltipText: string;
    type: WidgetType;
    valueFormatter: (val: number) => string;
    changeFormatter?: (val: number) => string;
};

export type WidgetsConfigSchema = {
    [key: string]: ConfigSchema;
};

export type PieChartSeries = {
    color: string;
    id: string;
    name: string;
    total: number;
    y: number;
};

export type PieChartDataSchema = {
    chartData: Array<PieChartSeries>;
    isEmpty: boolean;
} & GAPieData;
